<template>
  <WdsText small>
    <a
      href="https://help.worksome.dk/en/articles/10096959-requesting-payment-with-embedded-timesheets#h_c39f96399b"
      target="_blank"
      rel="noopener noreferrer"
    >
      <WdsStack gap-xs justify-center align-center>
        {{ $t('Learn more') }}
        <WdsIcon :name="WdsIconNameEnum.ARROW_UP_RIGHT" :size="16" />
      </WdsStack>
    </a>
  </WdsText>
</template>

<script setup lang="ts">
import { WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/composables/translation'
</script>

<style scoped lang="scss"></style>
